import { render, staticRenderFns } from "./whatsappsettings.vue?vue&type=template&id=996ae514&"
import script from "./whatsappsettings.vue?vue&type=script&lang=js&"
export * from "./whatsappsettings.vue?vue&type=script&lang=js&"
import style0 from "./whatsappsettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports